import {call, put, take, takeLatest} from "redux-saga/effects";
import {UserApi} from "../../../services/api/userApi";
import {WinStorage} from "../../../services/AuthSrorage";
import {LoadingStatus} from "../../status";
import {eventChannel} from "redux-saga";
import {userAC} from "./actionCreators";
import {
    AddEmailNotificationAI,
    AddOEMSettingAI,
    AddSupportContactAI,
    FetchCurrentEmailNotification,
    RemoveCurrentEmailNotification,
    ResetPasswordAI,
    SearchNotificationsAI,
    SendFeedbackAI,
    SignInAI,
    SignUpAI,
    ToggleWsNotificationAI,
    UpdateCurrentEmailNotification,
    UpdateUserDataAI,
    UserAT,
    VERIFY2FAAI,
} from "./actionTypes";
import history from "../../../helpers/history";
import {registration} from "../../../services/api/userRegistranitonApi";
import {SitesApi} from "../../../services/api/sitesApi";
import {sitesAC} from "../sites/actionCreators";
import {getLayoutSettingsForMainPage} from "../visual-dashboard/authSaga";
import {ApiConfig} from "../../../services/config";


export function* fetchQRCodeFor2FA() {
    const qr_code_base64 = yield call(UserApi.fetchQRcode);
} 

export function* fetchUserDataRequest() {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.me);
        const token = WinStorage.getToken();
        if (token && data) {
            WinStorage.setClient(data?.current_client?.id);
            yield put(userAC.setAuthKey(token));
            yield put(userAC.setUserData(data));
            yield put(userAC.is2FARequired());
        }
        if (!data) {
            yield call(LogOutRequest);
            yield put(userAC.setUserLoadingStatus(LoadingStatus.NEVER));
        }
    } catch (error) {
        history.push("/");
        WinStorage.removeToken();
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* fetchNotificationsCountRequest() {
    try {
        const count = yield call(UserApi.getNotificationsCount);
        yield put(userAC.setHeaderNotificationCount(count));
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* resetPasswordRequest({payload}: ResetPasswordAI) {
    try {
        const status = yield call(UserApi.resetPassword, payload);
        if (status === 200) {
            yield put(userAC.setUserRegisterStatus(LoadingStatus.RESET_PASSWORD_SUCCESS));
        } else {
            yield put(userAC.setUserRegisterStatus(LoadingStatus.RESET_PASSWORD_ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.RESET_PASSWORD_ERROR));
    }
}

export function* searchNotificationsRequest({payload}: SearchNotificationsAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.searchNotifications, payload);
        if (data.status === 200) {
            yield put(userAC.setNotifications(data.data));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.EXPORT_NOTIFICATIONS_ERROR));
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* shadowSearchNotificationsRequest({payload}: SearchNotificationsAI) {
    try {
        const data = yield call(UserApi.searchNotifications, payload);
        if (data.status === 200) {
            yield put(userAC.setShadowNotifications(data.data));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* LoginRequest({payload}: SignInAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.signIn, payload);
        if (data) {
            WinStorage.setToken(data.token);
            yield put(userAC.setAuthKey(data.token));
            yield put(userAC.fetchUserData());
            yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADED));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* RegisterRequest({payload}: SignUpAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(registration, payload);
        if (data.status === 201) {
            yield put(userAC.setUserRegisterStatus(LoadingStatus.SUCCESS));
            yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADED));
        } else {
            yield put(userAC.setUserRegisterStatus(LoadingStatus.ERROR));
            yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADED));
        }
    } catch (error) {
        yield put(userAC.setUserRegisterStatus(LoadingStatus.ERROR));
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* updateUserDataRequest({payload}: UpdateUserDataAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));

        if (!payload?.changePassword) {
            const status = yield call(UserApi.updateUser, payload);
            if (status === 200) {
                yield call(fetchUserDataRequest);
                history.push("/sites");
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_SUCCESS));
            } else {
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
            }
        } else {
            const updatePasswordStatus = yield call(UserApi.updateUserPassword, payload?.changePassword);
            const updateUserStatus = yield call(UserApi.updateUser, payload);

            if (updateUserStatus === 200) {
                yield call(fetchUserDataRequest);
                history.push("/sites");
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_SUCCESS));
            } else {
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
            }

            if (updatePasswordStatus === 200) {
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_PASSWORD_SUCCESS));
                history.push("/sites");
            } else {
                yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_PASSWORD_ERROR));
            }
        }

    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
    }
}

export function* LogOutRequest() {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        history.push("/");
        yield call(UserApi.logout);
        WinStorage.removeToken();
        yield put(userAC.setUserLoadingStatus(LoadingStatus.SUCCESS));
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* fetchEmailNotificationsRequest({payload}: FetchCurrentEmailNotification) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.getEmailNotifications,payload);
        if (data.status === 200) {
            const selectSites = yield call(SitesApi.getSites);
            yield put(sitesAC.setSites(selectSites));
            yield put(userAC.setEmailNotifications(data.data));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* addEmailNotificationRequest({payload}: AddEmailNotificationAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.addEmailNotification, payload);
        if (data.status === 201) {
            history.push("/user/setting/notification");
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* updateEmailNotificationRequest({payload}: UpdateCurrentEmailNotification) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.updateEmailNotification, payload);
        if (data.status === 200) {
            yield put(userAC.setCurrentEmailNotification(data.data));
            history.push("/user/setting/notification");
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* removeEmailNotificationRequest({payload}: RemoveCurrentEmailNotification) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.removeEmailNotification, payload);
        if (data.status === 204) {
            history.push("/user/setting/notification");
            yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADED));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.UPDATED_USER_ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function toggleNotificationSocket(path: string, device_udf_id?: string) {
    return eventChannel((emitter: any) => {
        const wsServerUrl = ApiConfig.getServerWssUrl();
        const ws: any = new WebSocket(`${wsServerUrl}${path}`);
        const token = window.localStorage.getItem("_token");

        const authCmd = {
            cmd: "auth",
            token: token,
        };

        ws.onopen = (event: any) => {
            ws.send(
                JSON.stringify(authCmd),
            );
        };

        ws.onerror = (error: any) => {
            console.log("WebSocket error " + error);
            console.dir(error);
        };

        ws.onmessage = (e: any) => {
            let message = null;
            try {
                message = JSON.parse(e.data);
            } catch (e) {
                // @ts-ignore
                console.error(`Error parsing : ${e.data}`);
            }
            if (message?.notifications?.length > 0) {
                return emitter({type: UserAT.SET_WS_NOTIFICATION, payload: message});
            }
        };

        return () => {
            console.log(`Socket off`);
            if (ws) {
                ws.close();
            }
        };
    });
}

let wsNotificationsChannel: any = null;

export function* runNotificationsSocket({payload}: ToggleWsNotificationAI) {
    if (payload.isOpen) {
        wsNotificationsChannel = yield call(toggleNotificationSocket, payload.path);
        while (true) {
            const action = yield take(wsNotificationsChannel);
            yield put(action);
        }
    } else {
        if (wsNotificationsChannel) {
            wsNotificationsChannel.close();
        }
    }
}


export function* fetchCurrentEmailNotificationsRequest({payload}: FetchCurrentEmailNotification) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.getCurrentEmailNotification, payload);
        if (data.status === 200) {
            yield put(userAC.setCurrentEmailNotification(data.data));
            history.push(`/user/setting/add/notification/${payload}`);
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* sendFeedbackRequest({payload}: SendFeedbackAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const status = yield call(UserApi.sendFeedback, payload);
        if (status === 201) {
            history.push("/");
            yield put(userAC.setUserLoadingStatus(LoadingStatus.SEND_FEEDBACK_SUCCESS));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.SEND_FEEDBACK_ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* fetchOEMSettingsRequest() {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.getOEMSettings);
        if (data) {
            yield put(userAC.setOEMSettings(data.results));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* fetchSupportContactsRequest() {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.getSupportContacts);
        if (data) {
            yield put(userAC.setSupportContacts(data));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* addOEMSettingsRequest({payload}: AddOEMSettingAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const status = yield call(UserApi.addOEMSettings, payload);
        if (status === 201) {
            yield call(fetchOEMSettingsRequest);
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}


export function* addSupportContactsRequest({payload}: AddSupportContactAI) {
    try {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.LOADING));
        const data = yield call(UserApi.addSupportContacts, payload);
        if (data) {
            yield put(userAC.setSupportContacts(data));
        } else {
            yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
        }
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}

export function* fetchLayoutSettingsRequest() {
    try {
        yield call(getLayoutSettingsForMainPage);
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
}


export function*  setup2FA() {
    try {
        const data =yield call(UserApi.setup2FA);
        yield put(userAC.setup2FASuccess(data));
        yield call(fetchUserAuthenticationDetail);
        yield put(userAC.setUserLoadingStatus(LoadingStatus.TWO_FACTOR_SETUP));
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.ERROR));
    }
};

export function*  verify2FA({payload} : VERIFY2FAAI) {
    try {
        const data =  yield call(UserApi.verify2FA,payload);

        WinStorage.set2FABeenVerified("True");
        yield call(fetchUserAuthenticationDetail);
        yield put(userAC.setUserLoadingStatus(LoadingStatus.TWO_FACTOR_VERIFIED));
    } catch (error) {
       yield put(userAC.setUserLoadingStatus(LoadingStatus.TWO_FACTOR_FAILED));  
    }
};


export function* fetchUserAuthenticationDetail() {
    try {
        const data = yield call(UserApi.is2FARequired);

        if(data.is_2fa_required){
            WinStorage.set2FARequired("True");
        }
        else{
            WinStorage.set2FARequired("False");
        }
        yield put(userAC.set2FADetail(data)); 
    } catch (error) {

    }
}

export function*  disable2FA() {
    try {
        const data =yield call(UserApi.disable2FA);
        yield call(fetchUserAuthenticationDetail);
        yield put(userAC.setUserLoadingStatus(LoadingStatus.TWO_FACTOR_DISABLED));
    } catch (error) {
        yield put(userAC.setUserLoadingStatus(LoadingStatus.TWO_FACTOR_DISABLED_FAILED));
    }
};


export function* userSaga() {
    yield takeLatest(UserAT.FETCH_SIGN_IN, LoginRequest);
    yield takeLatest(UserAT.SIGN_UP, RegisterRequest);
    yield takeLatest(UserAT.LOG_OUT, LogOutRequest);
    yield takeLatest(UserAT.FETCH_USER_DATA, fetchUserDataRequest);
    yield takeLatest(UserAT.FETCH_2FA_QR_CODE, fetchQRCodeFor2FA);
    yield takeLatest(UserAT.FETCH_HEADER_NOTIFICATIONS_COUNT, fetchNotificationsCountRequest);
    yield takeLatest(UserAT.SEARCH_NOTIFICATIONS, searchNotificationsRequest);
    yield takeLatest(UserAT.SHADOW_SEARCH_NOTIFICATIONS, shadowSearchNotificationsRequest);
    yield takeLatest(UserAT.UPDATE_USER_DATA, updateUserDataRequest);
    yield takeLatest(UserAT.FETCH_WS_NOTIFICATION, runNotificationsSocket);
    yield takeLatest(UserAT.FETCH_EMAIL_NOTIFICATIONS, fetchEmailNotificationsRequest);
    yield takeLatest(UserAT.FETCH_CURRENT_EMAIL_NOTIFICATIONS, fetchCurrentEmailNotificationsRequest);
    yield takeLatest(UserAT.ADD_EMAIL_NOTIFICATION, addEmailNotificationRequest);
    yield takeLatest(UserAT.UPDATE_CURRENT_EMAIL_NOTIFICATION, updateEmailNotificationRequest);
    yield takeLatest(UserAT.REMOVE_CURRENT_EMAIL_NOTIFICATION, removeEmailNotificationRequest);
    yield takeLatest(UserAT.SEND_FEEDBACK, sendFeedbackRequest);
    yield takeLatest(UserAT.FETCH_OEM_SETTINGS, fetchOEMSettingsRequest);
    yield takeLatest(UserAT.FETCH_SUPPORT_CONTACTS, fetchSupportContactsRequest);
    yield takeLatest(UserAT.ADD_OEM_SETTING, addOEMSettingsRequest);
    yield takeLatest(UserAT.ADD_SUPPORT_CONTACT, addSupportContactsRequest);
    yield takeLatest(UserAT.RESET_PASSWORD, resetPasswordRequest);
    yield takeLatest(UserAT.FETCH_LAYOUT_SETTINGS, fetchLayoutSettingsRequest);
    yield takeLatest(UserAT.SETUP_2FA, setup2FA);
    yield takeLatest(UserAT.VERIFY_2FA, verify2FA);
    yield takeLatest(UserAT.IS_2FA_Required, fetchUserAuthenticationDetail);
    yield takeLatest(UserAT.DISABLE_2FA, disable2FA);
}
